import { render, staticRenderFns } from "./CcBudget.ts.vue?vue&type=template&id=56ca8f85"
import script from "./CcBudget.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./CcBudget.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CcBudget.ts.vue?vue&type=style&index=0&id=56ca8f85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports